export default __webpack_public_path__ + "static/media/logo-ll.b0195863.png";